export default __webpack_public_path__ + "static/media/ra-pause.e3b51de7.svg";